import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;
const styles: Record<string, SxProps> = {
  titleWrapper: {
    padding: spacing(1)
  },
  base: {
    '.MuiDialog-root': {
      backgroundColor: palette.grey['50']
    }
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: palette.grey.main
  },
  title: {
    fontWeight: '700',
    color: palette.grey[500]
  },
  divider: {
    bgcolor: palette.lightishBluish.main,
    height: '0.125rem'
  },
  dialog: {
    backgroundColor: palette.grey['50'],
    borderRadius: '0px',
    width: '31.2rem'
  }
};

export default styles;
